import React from 'react'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Interweave from 'interweave'
import Section from '../../Section'

const CodeDocumentation = ({ report: { reportContent } }) => (
  <Section title="Code Documentation">
    <Interweave
      content={convertMdToHtml.makeHtml(reportContent.breakdownAndAutomatedAnalysis.docReviewText)}
    />
  </Section>
)

CodeDocumentation.propTypes = {
  report: PropTypes.object,
}

export default CodeDocumentation
